import { useMsal } from '@azure/msal-react';
import { Button, Card, Typography, Alert } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BRAND_NAME, TAGLINE } from '../../constants/branding';

const { Title, Paragraph } = Typography;

const LoginPage = () => {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();
  const [inFlight, setInFlight] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const from = (location.state as any)?.from?.pathname || '/workspace';

  useEffect(() => {
    if (accounts.length > 0) {
      instance.setActiveAccount(accounts[0]);
      navigate(from, { replace: true });
    }
  }, [accounts, navigate, from, instance]);

  const handleLogin = () => {
    if (inFlight) return;
    setErrorMsg(null);
    setInFlight(true);
    instance.loginRedirect({ scopes: ['User.Read'] }).catch((err: any) => {
      const code = err?.errorCode || err?.message || 'UNKNOWN_ERROR';
      console.warn('Login redirect failed', code, err);
      if (code === 'interaction_in_progress') {
        setErrorMsg('A login is already in progress. Please wait.');
      } else {
        setErrorMsg(`Login failed: ${code}`);
      }
      setInFlight(false);
    });
  };

  return (
    <div className="flex h-screen items-center justify-center bg-[#121826]">
      <Card className="w-[420px] bg-[#1F2937] border border-[#414756]">
        <Title level={3} className="!text-white !mb-0">{BRAND_NAME}</Title>
        <Paragraph className="!text-[#d1d5db]">{TAGLINE}</Paragraph>
        <Paragraph className="!text-[#9ca3af] !text-xs">Azure AD login placeholder – configure real tenant/client IDs in environment variables.</Paragraph>
        {errorMsg && (
          <Alert className="mb-4" type="warning" showIcon message={errorMsg} />
        )}
        <Button type="primary" block onClick={handleLogin} disabled={inFlight} loading={inFlight}>
          {inFlight ? 'Signing in…' : 'Sign in with Microsoft'}
        </Button>
      </Card>
    </div>
  );
};

export default LoginPage;
